import React, { Suspense } from 'react';
import Hero from '../../components/home/Hero';
import TrustedTech from '../../components/home/TrustedTech';
import SEOHead from '../../components/common/SEOHead';
import SectionDivider from '../../components/common/SectionDivider';
import { lazyWithRetry as lazy } from '../../utils/lazyWithRetry';

// Below-the-fold components lazy loaded to eliminate render-blocking JS for initial LCP
const AboutSection = lazy(() => import('../../components/home/AboutSection'));
const ServicesPreview = lazy(() => import('../../components/home/ServicesPreview'));
const FeaturedProjects = lazy(() => import('../../components/home/FeaturedProjects'));
const IndustriesPreview = lazy(() => import('../../components/home/IndustriesPreview'));
const WhyChooseUs = lazy(() => import('../../components/home/WhyChooseUs'));
const Process = lazy(() => import('../../components/home/Process'));
const AISection = lazy(() => import('../../components/home/AISection'));
const BlogPreview = lazy(() => import('../../components/home/BlogPreview'));
const Testimonials = lazy(() => import('../../components/home/Testimonials'));
const FAQPreview = lazy(() => import('../../components/home/FAQPreview'));
const FinalCTA = lazy(() => import('../../components/home/FinalCTA'));

export const Home = () => {
  return (
    <>
      <SEOHead
        title="BuildZone | Best Software Agency in Sialkot"
        description="BuildZone is the best software agency in Sialkot. We engineer custom software, mobile apps, enterprise ERPs, and AI solutions for global clients."
        keywords="Best Software House in Sialkot, Top Software House in Sialkot, Software House in Sialkot, Best Software Agency in Sialkot, Top Software Agency in Sialkot, Best IT Company in Sialkot, Software Development Sialkot, Web Development Sialkot, Mobile App Development Sialkot, AI Solutions Sialkot, ERP Systems Sialkot Pakistan, BuildZone Technology"
        canonical="https://buildzonetechnology.com/"
        schema={{
          "@context": "https://schema.org",
          "@type": ["LocalBusiness", "ProfessionalService", "Organization"],
          "name": "BuildZone Technology",
          "alternateName": [
            "Best Software Agency in Sialkot",
            "Top Software Agency in Sialkot",
            "BuildZone Software Agency",
            "Best Software House in Sialkot",
            "Top Software House in Sialkot",
            "BuildZone Software House"
          ],
          "url": "https://buildzonetechnology.com/",
          "logo": "https://buildzonetechnology.com/logo.png",
          "description": "Best Software Agency in Sialkot providing high-end custom software development, enterprise ERP solutions, mobile apps, and AI engineering.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Executive Tech District, Paris Road",
            "addressLocality": "Sialkot",
            "addressRegion": "Punjab",
            "postalCode": "51310",
            "addressCountry": "PK"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 32.4945,
            "longitude": 74.5229
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "150"
          }
        }}
      />

      <div className="flex flex-col">
        {/* Above the fold (instant paint, zero render-delay for H1 LCP) */}
        <Hero />
        <TrustedTech />

        <SectionDivider variant="cyan" label="ENGINEERING EXCELLENCE" />

        {/* Below the fold (streamed asynchronously with zero impact on LCP) */}
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <AboutSection />
          
          <SectionDivider variant="blue" label="CORE SERVICES" />
          
          <ServicesPreview />
          
          <SectionDivider variant="cyan" label="PORTFOLIO & CASE STUDIES" />
          
          <FeaturedProjects />
          
          <SectionDivider variant="purple" label="INDUSTRY DOMAINS" />
          
          <IndustriesPreview />
          
          <SectionDivider variant="blue" label="WHY BUILZONE" />
          
          <WhyChooseUs />
          
          <SectionDivider variant="cyan" label="DEVELOPMENT LIFECYCLE" />
          
          <Process />
          
          <SectionDivider variant="purple" label="INTELLIGENCE LABS" />
          
          <AISection />
          
          <SectionDivider variant="blue" label="TECH INSIGHTS" />
          
          <BlogPreview />
          
          <SectionDivider variant="emerald" label="CLIENT REVIEWS" />
          
          <Testimonials />
          
          <SectionDivider variant="cyan" label="FREQUENT QUESTIONS" />
          
          <FAQPreview />
          
          <SectionDivider variant="blue" />
          
          <FinalCTA />
        </Suspense>
      </div>
    </>
  );
};

export default Home;
